import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const oidcAuthority = process.env.REACT_APP_OIDC_AUTHORITY;
const oidcClientId = process.env.REACT_APP_OIDC_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));

if (oidcAuthority && oidcClientId) {
  const { AuthProvider, useAuth } = require('react-oidc-context');

  const oidcConfig = {
    authority: oidcAuthority,
    client_id: oidcClientId,
    redirect_uri: window.location.origin + '/callback',
    post_logout_redirect_uri: window.location.origin,
    scope: 'openid profile email',
    response_type: 'code',
    onSigninCallback: () => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };

  function AuthApp() {
    const auth = useAuth();
    return <App auth={auth} />;
  }

  root.render(
    <AuthProvider {...oidcConfig}>
      <AuthApp />
    </AuthProvider>
  );
} else {
  // No OIDC config - render without auth (dev mode)
  root.render(<App auth={null} />);
}
